import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import './ConfirmAdminSettingsModal.scss';

export type AdminSettingsChange = {
  deviceType: string;
  fromVersion: string | null;
  toVersion: string;
};

type ConfirmAdminSettingsModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  changes: AdminSettingsChange[];
  isLoading?: boolean;
};

export const ConfirmAdminSettingsModal: React.FC<ConfirmAdminSettingsModalProps> = ({
  open,
  onClose,
  onConfirm,
  changes,
  isLoading = false,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ className: 'confirm-admin-settings-modal' }}
  >
    <DialogTitle className="modal-title">Confirm Global Defaults</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="textSecondary" align="center" className="modal-subtitle">
        The following global default firmware releases will be updated
      </Typography>

      <div className="admin-settings-changes-list">
        {changes.map((change) => (
          <div className="admin-settings-change-item" key={change.deviceType}>
            <div className="admin-settings-change-label">{change.deviceType}</div>
            <div className="admin-settings-change-value">
              {change.fromVersion ?? 'Not set'} → {change.toVersion}
            </div>
          </div>
        ))}
      </div>
    </DialogContent>
    <DialogActions className="modal-actions">
      <Button variant="outlined" color="primary" onClick={onClose} disabled={isLoading}>
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" color="primary" disabled={isLoading}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);
